import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import ProductServices from '@root/modules/Sellers/Product/services/product';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Card, DatePicker, Menu, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import DropdownButton from '../../Inquiry/components/DropdownButton';
import SearchBox from '../../Inquiry/components/Search';
import BreadcrumbList from '../../Stock/components/Breadcrumb';

interface DataType {
  key: React.Key;
  no: number;
  productName: string;
  sku: number;
  quantity: number;
  updated_at: Date;
  warehouse: string;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const SellerProduct = () => {
  const [t] = useTranslate();
  const [list, setList] = useState([] as any);
  const history = useHistory();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItem, setTotaItem] = useState();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [labelType, setLabelType] = useState({
    key: '2',
    label: t('seller:button:select')
  } as any);
  const [proName, setProName] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [sort, setSort] = useState(true);

  const [dateValue, setDateValue] = useState<[string, string]>();
  const fromDt: string = (dateValue && dateValue[0]) || '';
  const toDt: string = (dateValue && dateValue[1]) || '';
  const [isSearch, setIsSearch] = useState('');

  const Breadcrumb = [
    {
      tittle: '상품 관리',
      url: ''
    },
    {
      tittle: '상품 조회',
      url: ''
    }
  ];

  const columns: ColumnsType<DataType> = [
    {
      title: 'No',
      dataIndex: 'key'
    },
    {
      title: t('table:seller:product-name'),
      dataIndex: 'productName'
    },

    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    {
      title: t('table:seller:quantity'),
      dataIndex: 'quantity'
    },
    {
      title: t('table:seller:logistic-center'),
      dataIndex: 'warehouse'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          입고 완료일
          {!!sort ? (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
              }}
            />
          ) : (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(true)}
            />
          )}
        </div>
      ),
      dataIndex: 'updated_at'
      // key: "updated_at",
    }
  ];
  // const getStatus = (e: any) => {
  //   setStatus(e.key);
  //   setLabelStatus({ key: e.key, label: e.domEvent.target.innerText });
  // };
  const getProductName = (e: any) => {
    setProName(e.key);
    setLabelType({ key: e.key, label: e.domEvent.target.innerText });
  };
  const onChangeState = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDate = (value: [string, string]) => {
    setDateValue(value);
  };

  const listLabel = [
    {
      id: 1,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getProductName}
          items={[
            {
              label: t('table:seller:product-name'),
              key: 'productName'
            },
            {
              type: 'divider'
            },
            {
              label: 'SKU',
              key: 'sku'
            }
          ]}
        />
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeyss: React.Key[], selectedRows: DataType[]) => {
      // setListExcel(selectedRows);
      setSelectedRowKeys(selectedRowKeyss);
    },
    getCheckboxProps: (record: DataType) => ({
      // disabled: record.productName === "Disabled User", // Column configuration not to be checked
      name: record.productName
    })
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY.MM.DD';

  const handelExportExcel = async (
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string
  ) => {
    if (selectedRowKeys.length > 0) {
      let selected = selectedRowKeys.map((item) => Number(item));
      const responseById = await ProductServices.exportExcelById(selected);
      const outputFilename = `Product_${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([responseById]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await ProductServices.exportExcel({
        fieldSearch,
        productName,
        sort,
        fromDt,
        toDt
      });
      const outputFilename = `Product_${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  const getPagination = async (
    page: number,
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string
  ) => {
    setLoading(true);
    try {
      const temp = await ProductServices.getPaging({
        productName,
        page,
        fieldSearch,
        sort,
        fromDt,
        toDt
      });
      let list = temp.data.map((item: any, index: number) => {
        return {
          ...item,
          updated_at: formatDateTime(item.updated_at),
          // updated_at: moment(item.updated_at)
          //   .utc(true ?? 9)
          //   .format('YYYY.MM.DD hh:mm:ss A'),
          no: index + 1,
          quantity: item?.inventory?.deliveredQuantity || 0,
          warehouse: item.warehouse.name,
          key: item.id
        };
      });
      setList(list);
      setTotalPages(temp.meta.totalPages);
      setCurrentPage(temp.meta.currentPage);
      setTotaItem(temp.meta.totalItems);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!!valueSearch && !!proName) setIsSearch(valueSearch);
    else if (!!isSearch && !valueSearch) setIsSearch('');
  }, [debounc, proName]);

  useEffect(() => {
    getPagination(1, proName, valueSearch, sort, fromDt, toDt);
  }, [isSearch, sort, fromDt, toDt]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>
          <div className="control">
            <RangePicker
              onChange={(date: any, dateString: [string, string]) => {
                getDate(dateString);
              }}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              // defaultValue={[
              //   moment(moment(), dateFormat),
              //   moment(moment(), dateFormat),
              // ]}
              format={dateFormat}
            />
            {listLabel.map((item) => {
              return (
                <DropdownButton
                  key={item.id}
                  label={labelType.label}
                  menu={item.listMenu}
                />
              );
            })}
            <SearchBox
              type
              onChange={(e: any) =>
                onChangeState('Value Search', e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>총 상품 {totalItem}</span>
                  <span className="table__head --right">
                    선택 상품
                    {selectedRowKeys.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    disabled={totalItem == 0}
                    onClick={() => {
                      handelExportExcel(
                        valueSearch,
                        proName,
                        sort,
                        fromDt,
                        toDt
                      );
                    }}
                  >
                    {t('common:download')}
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                rowSelection={rowSelection}
                pagination={{
                  total: totalPages * 10,
                  current: currentPage,
                  showSizeChanger: false,
                  onChange: (page, limit) => {
                    getPagination(
                      page,
                      valueSearch,
                      proName,
                      sort,
                      fromDt,
                      toDt
                    );
                  }
                }}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      history.push(`/admin/seller/product/${item.key}`);
                    }
                  };
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default SellerProduct;
